import {
  SidebarMenuButton,
  SidebarMenuItem,
} from "@arcadeai/design-system/components/ui/atoms/sidebar";
import { cn } from "@arcadeai/design-system/lib/utils";
import { Link } from "@tanstack/react-router";
import { useBadge } from "./hooks/use-badge";
import { useSidebarItemActive, useSidebarUrl } from "./hooks/use-sidebar-item";
import type { SidebarItem } from "./types";

type NavMenuItemProps = {
  item: SidebarItem;
};

export const NavMenuItem = ({ item }: NavMenuItemProps) => {
  const resolveUrl = useSidebarUrl();
  const itemUrl = resolveUrl(item.url);
  const isActive = useSidebarItemActive(
    {
      ...item,
      activeBasePath: resolveUrl(item.activeBasePath),
    },
    itemUrl
  );
  const badge = useBadge({ item, isActive });

  return (
    <SidebarMenuItem id={item.id} key={item.title}>
      {itemUrl ? (
        <Link preload="intent" to={itemUrl}>
          {({ isActive: routerIsActive }: { isActive: boolean }) => {
            const finalIsActive = item.activeOnChildRoutes
              ? isActive
              : routerIsActive;
            return (
              <SidebarMenuButton
                className={cn(finalIsActive && "text-white")}
                isActive={finalIsActive}
                tooltip={item.title}
              >
                {!!item.icon && <item.icon />}
                <span>{item.title}</span>
                {badge}
              </SidebarMenuButton>
            );
          }}
        </Link>
      ) : (
        <SidebarMenuButton tooltip={item.title}>
          {!!item.icon && <item.icon />}
          <span>{item.title}</span>
          {badge}
        </SidebarMenuButton>
      )}
    </SidebarMenuItem>
  );
};
